<div class="grid grid-cols-7">
  <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4">sun</div>
  <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4">mon</div>
  <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4">tue</div>
  <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4">wed</div>
  <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4">thu</div>
  <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4">fri</div>
  <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4">sat</div>
  <div
    *ngFor="let point of points$ | async; trackBy: 'index' | trackByKey"
    (mouseenter)="setHoveredPoint(point)"
    (mouseleave)="setHoveredPoint(null)"
    class="h-6 flex flex-col items-center justify-center select-none {{ point.backgroundClass }} {{ point.textClass }}"
  >
    <ng-container *ngIf="!point.isInThePast && !point.isToday; else justDate">
      {{ hoveredPoint === point ? point.count : point.dayOfMonth }}
      <span *ngIf="hoveredPoint === point" class="text-xs">Trucks</span>
    </ng-container>
    <ng-template #justDate>
      {{ point.dayOfMonth }}
    </ng-template>
  </div>
</div>
